import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';
import Clients from '../components/Clients';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Index: React.FC = () => {
  const [isInIframe, setIsInIframe] = useState(false);
  
  // Check if running in iframe
  useEffect(() => {
    try {
      setIsInIframe(window.self !== window.top);
    } catch (e) {
      setIsInIframe(true); // If access to parent window is denied, we're in an iframe
    }
  }, []);
  
  // Smooth scroll to anchor with iframe awareness
  useEffect(() => {
    const handleAnchorLinkClick = (event: MouseEvent) => {
      const target = event.target as HTMLAnchorElement;
      if (target.tagName === 'A' && target.hash && target.hash.startsWith('#')) {
        event.preventDefault();
        
        const element = document.querySelector(target.hash);
        if (element) {
          const headerOffset = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          
          // Update URL without reload if not in iframe
          if (!isInIframe) {
            window.history.pushState(null, '', target.hash);
          }
          
          // Communicate with parent if in iframe
          if (isInIframe) {
            try {
              window.parent.postMessage({
                type: 'navigation',
                hash: target.hash,
                scrollTop: offsetPosition
              }, '*');
            } catch (err) {
              console.log('Could not communicate with parent frame');
            }
          }
        }
      }
    };
    
    document.addEventListener('click', handleAnchorLinkClick);
    
    // Listen for messages from parent
    const handleParentMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === 'scrollTo') {
        const element = document.querySelector(event.data.selector);
        if (element) {
          const headerOffset = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    };
    
    if (isInIframe) {
      window.addEventListener('message', handleParentMessage);
    }
    
    return () => {
      document.removeEventListener('click', handleAnchorLinkClick);
      if (isInIframe) {
        window.removeEventListener('message', handleParentMessage);
      }
    };
  }, [isInIframe]);
  
  // Add page transitions
  useEffect(() => {
    const fadeInElements = document.querySelectorAll('.fade-in-view');
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    
    fadeInElements.forEach((el) => observer.observe(el));
    
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`min-h-screen ${isInIframe ? 'iframe-mode' : ''}`}>
      <Navbar />
      <main>
        <Hero />
        <Clients />
        <Services />
        <About />
        <Process />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
